import { h, Fragment } from "preact";
import { useState, useEffect } from "preact/hooks";
import register from "preact-custom-element";
import useProduct from "../../helpers/useProduct/useProduct";
import unifyGroupVariants from "../../helpers/unifyGroupVariants";
import StockMessage from "./stock-message";
import stockMessageInputs from "./stockMessageInputs";
import StockMessageContent from "./stock-message-content";

function StockStatus({ productId, variantId, quantityRequested, countryCode }) {
  const [productData] = useProduct(productId);
  const [variants, setVariants] = useState([]);
  const [allocatedComponents, setAllocatedComponents] = useState(
    window.cartData?.allocatedComponents || {},
  );

  const selectedVariant =
    variants.find((variant) => variant.id === variantId) || null;

  useEffect(() => {
    const unifiedVariants = unifyGroupVariants(productData);
    setVariants(unifiedVariants);
  }, [productData, setVariants]);

  useEffect(() => {
    const handleCartUpdate = () =>
      setAllocatedComponents(window.cartData.allocatedComponents);

    document.addEventListener("cart:updated", handleCartUpdate);

    return () => document.removeEventListener("cart:updated", handleCartUpdate);
  }, []);

  if (!selectedVariant || JSON.parse(selectedVariant.hideOnPdp)) return null;

  if (countryCode === "AU") {
    const auMessages = {
      in_stock: {
        tooltip: window.localeStrings.stock_message_au.tooltip_in_stock,
        lines: [
          {
            text: window.localeStrings.stock_message_au.in_stock.line_1,
            color: "var(--color-secondary)",
          },
        ],
      },
      in_stock_usa: {
        tooltip: window.localeStrings.stock_message_au.tooltip_in_stock_usa,
        lines: [
          {
            text: window.localeStrings.stock_message_au.in_stock_usa.line_1,
            color: "var(--color-secondary)",
          },
        ],
      },
    };
    const { auStockMessage } = selectedVariant;
    if (!auStockMessage || !(auStockMessage in auMessages)) return null;

    const auMessage = auMessages[auStockMessage];
    return (
      <>
        <input
          type="hidden"
          name="properties[_stock_message]"
          value={auMessage.lines[0].text}
        />
        <input type="hidden" name="properties[_stock_status]" value="inStock" />
        <StockMessageContent message={auMessage} />
      </>
    );
  }

  return (
    <StockMessage
      {...stockMessageInputs({
        variant: selectedVariant,
        quantityRequested,
        allocatedComponents,
      })}
      localeStrings={window.localeStrings.stock_message}
    />
  );
}

if (!customElements.get("stock-status")) {
  register(
    StockStatus,
    "stock-status",
    ["product-id", "variant-id", "quantity-requested", "country-code"],
    {
      shadow: false,
    },
  );
}
